module.exports = "/static/media/message.f336a4e0.svg";